import { atom } from "recoil";

export const urlState = atom<string | null>({
  key: "urlState",
  default: null,
});
